import { createAction } from 'redux-actions';

export type SetActiveRecommendedSeats = ReturnType<typeof setActiveRecommendedSeats>;

export const setActiveRecommendedSeats = createAction<boolean>('SET_ACTIVE_RECOMMENDED_SEATS');

export const toggleActiveRecommendedSeats = createAction('TOGGLE_ACTIVE_RECOMMENDED_SEATS');
